import { createContext, useContext } from 'react';
import { ColorFunction } from '@styles/colors/types';
import { font as initialFont } from '@styles/fonts';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

export interface OperatorPanelSettingsWrapperContextValue {
  C: ColorFunction;
  scale: ScaleFunction;
  font: typeof initialFont;
  onDefaultClose: () => void;
}

export const OperatorPanelSettingsWrapperContext = createContext<OperatorPanelSettingsWrapperContextValue | null>(null);

export const useOperatorPanelSettingsWrapperContext = () => {
  const context = useContext(OperatorPanelSettingsWrapperContext);
  if (!context) {
    throw new Error('OperatorPanelSettingsWrapper compound components must be used within OperatorPanelSettingsWrapper.Root');
  }
  return context;
};
